import { Validators } from '@angular/forms';
import { FieldsOptions } from '@sim/form';

import { SourceBibliographic } from '../source-bib';

// tslint:disable-next-line:no-empty-interface
export interface SourceBib {
  docBib: string;
  ordine: number;
  riferimento: string;
}

export interface SourceBibCard {
  docBib: SourceBibliographic;
  ordine: number;
  riferimento: string;
}

export const SourceBibMeta: FieldsOptions<SourceBib> = {
  docBib: { validators: Validators.required },
  ordine: { validators: Validators.required },
  riferimento: { validators: Validators.required },
};
